import '@fontsource/inter/variable.css';
import { BaukastenProvider } from '@hygraph/baukasten';
import type { AppProps } from 'next/app';
import React from 'react';

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <BaukastenProvider global>
      <div>
        <Component {...pageProps} />
      </div>
    </BaukastenProvider>
  );
}

export default MyApp;
